/**
 * SW version, compiled in at build time via the `__SW_VERSION__` define in
 * vite.config.ts. Windows query it from a (waiting) worker with a
 * GET_VERSION message to drive the update flow.
 */

import { normalizeChangelog } from '../lib/changelog';

declare const __SW_VERSION__: string | undefined;

export const SW_VERSION: string =
  typeof __SW_VERSION__ !== 'undefined' ? __SW_VERSION__ : 'dev';

/**
 * Changelog compiled into THIS SW bundle (same env source as the window's
 * config/version.ts). A waiting worker replies with it to GET_VERSION so the
 * window can show the *new* version's release notes — the window's own
 * CHANGELOG constant is the old build's. Normalized the same way as that
 * constant so the raw escaped `\n` sequences never reach the viewer.
 */
const rawChangelog =
  (import.meta.env?.VITE_APP_CHANGELOG as string | undefined) || undefined;

export const SW_CHANGELOG: string | undefined = rawChangelog
  ? normalizeChangelog(rawChangelog)
  : undefined;
